import { produce } from 'immer';

import { defaultState, reducer as coreReducer } from '@core/js/hooks/useGetJackpots/store/reducer';
import * as Types from '@core/js/hooks/useGetJackpots/store/types';

import { actionTypes } from '../sun/store/constants';
import { TJackpotsAction } from '../sun/store/types';

export const reducer = produce((draftState, action: TJackpotsAction): Types.IJackpotState | void => {
    switch (action.type) {
        case actionTypes.JACKPOTS_EXTERNAL_FETCH: {
            if (!action.payload) {
                break;
            }

            draftState.jackpots = {
                ...draftState.jackpots,
                ...action.payload
            };

            draftState.jackpotStartTime = Date.now();

            break;
        }

        default:
            return coreReducer.call(this, draftState as Types.IJackpotState, action) as Types.IJackpotState;
    }
}, defaultState);
